import type { ICard } from "../../cardsSlice";

export const major18Card: ICard = {
    id: "major_18",
    arcana: "major",
    number: 18,
    suit: "major",
    court: "major",
    name: "Луна",
    nameEn: "The Moon",
    keywords: ["Иллюзии", "Бессознательное", "Интуиция"],
    symbolism: [
      "Полнолуние с лицом",
      "Волк и собака воют",
      "Рак выходит из воды",
      "Две башни, извилистая дорога"
    ],
    symbolismInterpretation:
      "Символ скрытого, таинственного, неосознанного. Иллюзорность восприятия и глубины психики",
    archetype: "Архетип великой матери, тени и сна",
    psychology: "Столкновение со страхами, путаница, повышенная чувствительность",
    upright: {
      personality: "Неуверенность, чувствительность, сильная интуиция",
      relationships: "Иллюзии, неясность, недосказанность",
      work: "Скрытые процессы, запутанные обстоятельства",
      spirituality: "Погружение в бессознательное, работа с тенями",
      examples: ["Интуитивные прозрения", "Обманчивые ситуации", "Скрытые мотивы"]
    },
    reversed: {
      meaning: "Прояснение, исчезновение страхов, потеря связи с интуицией",
      nuances: "Сложность отличить воображаемое от реального"
    },
    associations: ["Ночь", "Сны", "Отражение", "Страх"],
    combinations: ["С Солнцем — выход из иллюзий", "С Повешенным — погружение в подсознание"],
    readingTips: ["Проверять факты, если есть сомнения", "Доверять интуиции, но не слепо"],
    selfQuestions: ["Чего я боюсь увидеть?", "Где я могу заблуждаться?"]
  };


